import { render, staticRenderFns } from "./hot-goods.vue?vue&type=template&id=6a64a0d2&scoped=true"
import script from "./hot-goods.vue?vue&type=script&lang=js"
export * from "./hot-goods.vue?vue&type=script&lang=js"
import style0 from "./hot-goods.vue?vue&type=style&index=0&id=6a64a0d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64a0d2",
  null
  
)

export default component.exports